import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex)

import {
    companion,
    companionFilter,
    collection,
    nugget,
    uitexts,
    header,
    knowledgeTest,
    authentication,
    generalEntry,
    page,
    me,
    kam,
    appointment,
    standGuidance,
} from "./modules";

export default new Vuex.Store({
    modules: {
        authentication,
        uitexts,
        companion,
        companionFilter,
        collection,
        nugget,
        header,
        knowledgeTest,
        generalEntry,
        page,
        me,
        kam,
        appointment,
        standGuidance,
    }
})
